<script>
export default {
  name: 'IconDolarSquare',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.03145 5.05005V6.83755L6.4002 6.6188C6.08145 6.5063 5.8877 6.40005 5.8877 5.8563C5.8877 5.41255 6.21895 5.05005 6.6252 5.05005H7.03145Z"
      :fill="color"
    />
    <path
      d="M9.1125 9.14373C9.1125 9.58748 8.78125 9.94998 8.375 9.94998H7.96875V8.16248L8.6 8.38123C8.91875 8.49373 9.1125 8.59998 9.1125 9.14373Z"
      :fill="color"
    />
    <path
      d="M10.1188 1.25H4.88125C2.60625 1.25 1.25 2.60625 1.25 4.88125V10.1188C1.25 12.3938 2.60625 13.75 4.88125 13.75H10.1188C12.3938 13.75 13.75 12.3938 13.75 10.1188V4.88125C13.75 2.60625 12.3938 1.25 10.1188 1.25ZM8.9125 7.5C9.4 7.66875 10.05 8.025 10.05 9.14375C10.05 10.1062 9.3 10.8875 8.375 10.8875H7.96875V11.25C7.96875 11.5063 7.75625 11.7188 7.5 11.7188C7.24375 11.7188 7.03125 11.5063 7.03125 11.25V10.8875H6.80625C5.78125 10.8875 4.95 10.0188 4.95 8.95625C4.95 8.7 5.15625 8.4875 5.41875 8.4875C5.675 8.4875 5.8875 8.7 5.8875 8.95625C5.8875 9.50625 6.3 9.95 6.80625 9.95H7.03125V7.83125L6.0875 7.5C5.6 7.33125 4.95 6.975 4.95 5.85625C4.95 4.89375 5.7 4.1125 6.625 4.1125H7.03125V3.75C7.03125 3.49375 7.24375 3.28125 7.5 3.28125C7.75625 3.28125 7.96875 3.49375 7.96875 3.75V4.1125H8.19375C9.21875 4.1125 10.05 4.98125 10.05 6.04375C10.05 6.3 9.84375 6.5125 9.58125 6.5125C9.325 6.5125 9.1125 6.3 9.1125 6.04375C9.1125 5.49375 8.7 5.05 8.19375 5.05H7.96875V7.16875L8.9125 7.5Z"
      :fill="color"
    />
  </svg>
</template>
